uniform float uRadius; // The sphere's radius
varying vec2 vUv; // Pass UV to the fragment shader

void main() {
    vUv = uv;
    vec3 pos = position;

    //Bend the plane according to radius and distance to center
    float dist = length(pos.xy);
    float depth = uRadius - sqrt(uRadius * uRadius - dist * dist);
    pos.z -= depth;

    // 
    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
}
